import React, { useRef } from "react"
import { Divider } from "@material-ui/core"
import { Trans, t } from "@lingui/macro"
import { DateTimePicker } from "../DateTimePickers/DateTimePicker"
import { RowBox } from "../Boxes/RowBox"
import { ProcessCollapse } from "./ProcessCollapse"

const DateTimeStep = ({
  expand,
  value,
  onChange,
  isScheduled,
  classes,
  disabled = false,
  collapseTimeout = "auto"
}) => {
  const inputRef = useRef()

  const handleChange = (date) => {
    onChange && onChange(date)
    setTimeout(() => {
      try {
        inputRef.current.blur()
      } catch (error) {
        // ignore
      }
    })
  }

  return (
    <ProcessCollapse in={expand} timeout={collapseTimeout}>
      <Divider className={classes.divider} />
      <RowBox p={2}>
        <DateTimePicker
          value={value || null}
          placeholder={t`Select date and time`}
          onChange={handleChange}
          disabled={isScheduled || disabled}
          clearable
          clearLabel={<Trans>Clear</Trans>}
          inputRef={inputRef}
          showTodayButton
          todayLabel={<Trans>Now</Trans>}
          cancelLabel=""
          okLabel={<Trans>OK</Trans>}
          autoOk={false}
          minutesStep={1}
        />
      </RowBox>
    </ProcessCollapse>
  )
}

export { DateTimeStep }
